
export default class RouteHelper {

  /**
   * get the nearest point on the line latlngs array
   * we return index to put this point in the line after the first point (index + 1)
   *
   * @param line
   * @param point
   */
  static getProjectionPoint(line, point){
    let minDistance = 15
    let nearestPoint = null
    let index = -1

    for (let i = 0; i < line.length - 1; i++) {
      const segmentStart = line[i];
      const segmentEnd = line[i + 1];
      const projection = RouteHelper.PointOnSegment(point, segmentStart, segmentEnd);
      const distance = L.latLng(projection).distanceTo(L.latLng(point));
      if (distance < minDistance) {
        minDistance = distance;
        nearestPoint = projection;
        index = i
      }
    }

    return { nearestPoint, index }
  }

  /**
   * get the nearest point between two point
   * @param point
   * @param segmentStart
   * @param segmentEnd
   * @returns {*|*[]}
   * @constructor
   */
  static PointOnSegment(point, segmentStart, segmentEnd) {

    const x0 = point[0], y0 = point[1]
    const x1 = segmentStart[0], y1 = segmentStart[1]
    const x2 = segmentEnd[0], y2 = segmentEnd[1];

    const dx = x2 - x1;
    const dy = y2 - y1;

    if (dx === 0 && dy === 0) {
      return segmentStart;
    }

    const t = ((x0 - x1) * dx + (y0 - y1) * dy) / (dx * dx + dy * dy);

    if (t < 0) return segmentStart;
    if (t > 1) return segmentEnd;

    return [x1 + t * dx, y1 + t * dy];
  }

}